<div class="flow-canvas">

  @for (node of data.nodes; track node) {
    <app-zs-flow-action-node [nodedata]="node" [attr.id]="node.id"></app-zs-flow-action-node>
  }

</div>
<!-- <span *ngFor="let node of edges">
<zs-node-connector class="zs-node-connector" from="#{{node.source}}" to="#{{node.target}}" within=".flow-canvas"></zs-node-connector>
</span> -->